'use client'

import React from 'react'

type IconProps = {
  prefix?: 'fa-solid' | 'fa-regular' | 'fa-light' | 'fa-brands'
  icon: string
  size?: 'xs' | 'sm' | 'lg' | 'xl' | '2xl' | '3x' | '4x' | '5x'
  spin?: boolean
  className?: string
}

export const Icon: React.FC<IconProps> = ({
  prefix,
  icon,
  size,
  spin = false,
  className = '',
}) => {
  if (!prefix || !icon) {
    return null
  }

  const sizeClass = size ? `fa-${size}` : ''
  const spinClass = spin ? 'fa-spin' : ''

  return (
    <i
      className={`${prefix} fa-${icon} ${sizeClass} ${spinClass} ${className}`.trim()}
      aria-hidden="true"
    ></i>
  )
}
